module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/three_dots-f9e3c4add56dcd66d6d2c3018b010404.svg";